var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VApp',[_c('LoadingDialog',{ref:"loading"}),(_vm.autenticado)?_c('div',[_c('NavBar'),_c('v-content',[_c('Comanda'),_c('keep-alive',[_c('router-view')],1)],1)],1):_vm._e(),(_vm.autenticado === false)?_c('div',[_c('BannerErro',{attrs:{"mensagem":"Usuário não está autenticado"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }